var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotesCloseIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 41,
    viewBox: "0 0 39 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8249",
    "data-name": "Group 8249",
    transform: "translate(-1077 -87)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_3329",
    "data-name": "Rectangle 3329",
    d: "M17,0H39a0,0,0,0,1,0,0V34a0,0,0,0,1,0,0H17A17,17,0,0,1,0,17v0A17,17,0,0,1,17,0Z",
    transform: "translate(1116 121) rotate(180)",
    fill: "#0177b5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-arrow-left",
    "data-name": "Icon feather-arrow-left",
    transform: "translate(1103.9 110.072) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13900",
    "data-name": "Path 13900",
    d: "M19.674,18H7.5",
    transform: "translate(-7.5 -11.827)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13901",
    "data-name": "Path 13901",
    d: "M13.716,19.846,7.5,13.673,13.716,7.5",
    transform: "translate(-7.5 -7.5)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13903",
    "data-name": "Path 13903",
    d: "M3065,1715l10,7v-7Z",
    transform: "translate(-1988 -1594)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotesCloseIcon);
export default __webpack_public_path__ + "static/media/NotesCloseIcon.c1ce6da08076b6c26eba8b991167c8be.svg";
export { ForwardRef as ReactComponent };